import React from 'react';

const Vue_First_SFC = () => {
  return (
    <div>
      <h1>Vue_First_SFC Component</h1>
      <p>This is the Vue_First_SFC tutorial page.</p>
    </div>
  );
}

export default Vue_First_SFC;
